import { createContext } from 'react';

interface Context {
  first_name: string;
}

export const EmployeeTimeLogsContext = createContext({} as Context);

export const EmployeeTimeLogsProvider = EmployeeTimeLogsContext.Provider;
